var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4446",
    "data-name": "Rectangle 4446",
    width: 24,
    height: 24,
    transform: "translate(60 179)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inventory",
    transform: "translate(-60 -179)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inventory-2",
    "data-name": "Inventory",
    transform: "translate(43 108.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11085",
    "data-name": "Path 11085",
    d: "M26.1,85.153H23.051A3.051,3.051,0,0,1,20,82.1V79.051A3.051,3.051,0,0,1,23.051,76H26.1a3.051,3.051,0,0,1,3.051,3.051V82.1A3.051,3.051,0,0,1,26.1,85.153Z",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11086",
    "data-name": "Path 11086",
    d: "M103.051,156h0a1.525,1.525,0,0,1-1.525,1.525h0A1.525,1.525,0,0,1,100,156h0",
    transform: "translate(-76.949 -76.949)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11087",
    "data-name": "Path 11087",
    d: "M332,76h3.051a3.051,3.051,0,0,1,3.051,3.051V82.1a3.051,3.051,0,0,1-3.051,3.051",
    transform: "translate(-300.102)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11088",
    "data-name": "Path 11088",
    d: "M335.051,156h0a1.525,1.525,0,0,1-1.525,1.525h0A1.525,1.525,0,0,1,332,156h0",
    transform: "translate(-300.102 -76.949)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11089",
    "data-name": "Path 11089",
    d: "M36.475,316H21.525a1.525,1.525,0,0,0,0,3.051h1.525a1.525,1.525,0,0,0,3.051,0h5.8a1.525,1.525,0,0,0,3.051,0h1.525a1.525,1.525,0,0,0,0-3.051Z",
    transform: "translate(0 -230.847)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryActiveIcon);
export default __webpack_public_path__ + "static/media/Inventory_Active_Icon.52e5670b0272a6837388b9b171773b91.svg";
export { ForwardRef as ReactComponent };